"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskFromOperationNode = exports.taskToOperationNode = exports.operationConvertors = void 0;
const common_1 = require("@finley-technologies/common");
const converter_1 = require("./operations/ai2csv/converter");
const converter_2 = require("./operations/asset2json/converter");
const converter_3 = require("./operations/attachHeader/converter");
const converter_4 = require("./operations/edit/converter");
const converter_5 = require("./operations/filter/converter");
const converter_6 = require("./operations/flatten/converter");
const converter_7 = require("./operations/join/converter");
const converter_8 = require("./operations/pdf2csv/converter");
const converter_9 = require("./operations/preFilter/converter");
const converter_10 = require("./operations/pyCsvVirtualSheet/converter");
const converter_11 = require("./operations/pyXlsx2csv2/converter");
const converter_12 = require("./operations/pyXlsxVirtualSheet2Csv/converter");
const converter_13 = require("./operations/sanitize/converter");
const converter_14 = require("./operations/stack/converter");
const converter_15 = require("./operations/unzip/converter");
const converter_16 = require("./operations/xlsx2csv/converter");
const converter_17 = require("./operations/xlsx2csv2/converter");
exports.operationConvertors = {
    ai2Csv: converter_1.convertor,
    asset2json: converter_2.convertor,
    attachHeader: converter_3.convertor,
    edit: converter_4.convertor,
    filter: converter_5.convertor,
    flatten: converter_6.convertor,
    join: converter_7.convertor,
    pdf2csv: converter_8.convertor,
    preFilter: converter_9.convertor,
    sanitize: converter_13.convertor,
    xlsx2csv: converter_16.convertor,
    xlsx2csv2: converter_17.convertor,
    pyXlsx2Csv2: converter_11.convertor,
    pyXlsxVirtualSheet2Csv: converter_12.convertor,
    pyCsvVirtualSheet: converter_10.convertor,
    unzip: converter_15.convertor,
    stack: converter_14.convertor,
};
const operationConvertorArray = Object.values(exports.operationConvertors);
const getConvertorByOperation = (operation) => {
    const converter = operationConvertorArray.find((con) => con.operation === operation);
    (0, common_1.finleyAssert)(converter, `no converter found for operation: ${operation}`);
    return converter;
};
const getConvertorByNodeType = (nodeType) => {
    const converter = operationConvertorArray.find((con) => con.nodeType === nodeType);
    (0, common_1.finleyAssert)(converter, `no converter found for nodeType: ${nodeType}`);
    return converter;
};
const taskToOperationNode = ({ task }) => {
    const converter = getConvertorByOperation(task.operation);
    return converter.taskToOperationNode(task);
};
exports.taskToOperationNode = taskToOperationNode;
const taskFromOperationNode = ({ srcNodes, operationNode, }) => {
    const converter = getConvertorByNodeType(operationNode.metadata.tapeBuilderNodeType);
    return converter.taskFromOperationNode({ srcNodes, operationNode });
};
exports.taskFromOperationNode = taskFromOperationNode;
//# sourceMappingURL=operationConvertors.js.map